import {
  createContext,
  useEffect,
  useState,
  useCallback,
  useContext,
} from "react";
import { SignInContext } from "../../providers/SignInProvider";
import logo from '../media/cegoslogo.png';


const GoogleLogin = ({}) => {
  const { logGoogleUser } = useContext(SignInContext);

  const handleLogin = async (e) => {
    e.preventDefault();
    await logGoogleUser();
  };

  //If the user is already logged in, redirect to the home page
  const { user } = useContext(SignInContext);
  useEffect(() => {
    if (user) {
      window.location.href = "/home";
    }
  }, [user]);

  return (
    <div className="relative flex flex-col items-center justify-center h-screen ">
   
    <div 
      className="absolute inset-0  bg-repeat  opacity-30"
      style={{ backgroundImage: `url(${logo})` }}
    ></div>

    <div className="relative z-10 bg-white p-8 rounded shadow-md w-full max-w-sm border border-gray-300">
      <h1 className="text-2xl font-bold mb-4">Sign In</h1>
      <p className="mb-6">Sign in to access <span className="font-bold">Events Hub</span></p>
      <button
        className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded w-full"
        onClick={handleLogin}
      >
        Sign In With Google
      </button>
    </div>
  </div>
  );
};

export default GoogleLogin;
